import React from "react";
import { useScrollContainer } from "../../hooks/useScrollContainer";
import { Arrow, SliderContainer, SliderWrapper } from "./AssetSlider.styled";
import { BlueLeftArrow } from "../Icons/BlueLeftArrow";
import { BlueRightArrow } from "../Icons/BlueRightArrow";

export const AssetSlider = ({ children, show = true, sliderHeight = 50, assetsGap = 3 }) => {
  const { scrollContainer, showButtons, scrollLeft, scrollRight } = useScrollContainer();

  return (
    <SliderContainer height={sliderHeight} show={show}>
      {showButtons && (
        <Arrow onClick={scrollLeft} className="left">
          <BlueLeftArrow />
        </Arrow>
      )}

      <SliderWrapper ref={scrollContainer} $showButtons={showButtons} $assetsGap={assetsGap}>
        {children}
      </SliderWrapper>

      {showButtons && (
        <Arrow onClick={scrollRight} className="right">
          <BlueRightArrow />
        </Arrow>
      )}
    </SliderContainer>
  );
};
